import classNames from 'classnames'
import i18next from 'i18next'
import { useContext, useEffect } from 'react'
import general404 from '../../assets/icons/default-404.svg'
import { MainContainer } from '../../trackdelivery/components/MainContainer'
import Header from '../components/Header'
import { ThemeContext } from '../contexts/ThemeContext'
import { isBringOrPostenTheme, themeClassName } from '../utils/theme'

const PageNotFound = () => {
  const { theme } = useContext(ThemeContext)
  useEffect(() => {
    // Log to Sentry
    console.warn('Page not found', window.location.href)
  }, [])

  return (
    <div className={themeClassName(theme)}>
      <Header activeHeader={'hidden'} />
      <MainContainer className={classNames('full-height', isBringOrPostenTheme(theme) && 'bg-white!')}>
        <GeneralContent />
      </MainContainer>
    </div>
  )
}

const GeneralContent = () => (
  <>
    <ShowNotFoundImage />
    <div className="flex flex-col items-center gap-7 text-center">
      <h1 className="font-bold text-5xl">{i18next.t('pageNotFound.title')}</h1>
      {i18next.t('pageNotFound.message')}
    </div>
  </>
)

const ShowNotFoundImage = () => (
  <figure className="flex flex-col items-center">
    <img src={general404} alt={i18next.t('imageAlt.pageNotFound')} />
  </figure>
)

export default PageNotFound
